import YellowHeroHue from '@assets/hue_hero.svg';
import RedHue from '@assets/hue_red.svg';
import YellowHue from '@assets/hue_yellow.svg';
import MotionWrapper from '@atoms/MotionWrapper/MotionWrapper';
import GlowColourEnum from '@models/enums/GlowColourEnum';
import type { MotionStyle } from 'framer-motion';

type HueColour = Exclude<GlowColourEnum, GlowColourEnum.None>;

interface Props {
  readonly className?: string;
  readonly colour: HueColour;
  readonly dataTestId?: string;
  readonly motionStyle?: MotionStyle;
}

const mapHueColourToHueBackground = {
  [GlowColourEnum.Yellow]: YellowHue,
  [GlowColourEnum.Red]: RedHue,
  [GlowColourEnum.YellowFaint]: YellowHeroHue,
};

const BackgroundHue = ({
  className,
  colour,
  dataTestId,
  motionStyle,
}: Props) => {
  const sharedProps = {
    src: `${mapHueColourToHueBackground[colour]}`,
    className,
    'data-testid': dataTestId,
    'aria-hidden': 'true' as const,
  };

  if (motionStyle) {
    return (
      <MotionWrapper tag="img" alt="" style={motionStyle} {...sharedProps} />
    );
  }

  return <img alt="" {...sharedProps} />;
};

export default BackgroundHue;
